import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import flatListToHierarchical from '../../utils/flatListToHierarchical';
import {
  CustomAccordion,
  CustomAccordionItem,
  CustomAccordionItemHeading,
  CustomAccordionItemButton,
  CustomAccordionItemPanel,
} from '../UI/CustomAccordion/CustomAccordion';
import NavList from '../UI/NavList/NavList';
import Section from '../UI/Section/Section';
import Type from '../UI/Type/Type';
import * as styles from './FaqLayout.module.scss';

const FAQ_MENU_QUERY = graphql`
  query FaqMenuQuery {
    categories: allWpFaqCategory {
      nodes {
        id
        parentId
        name
        uri
      }
    }
  }
`;

const FaqLayout = ({ categoryId, children }) => {
  const { categories } = useStaticQuery(FAQ_MENU_QUERY);
  const categoryNodes = flatListToHierarchical(categories.nodes);
  const activeNodeIndex = categoryNodes
    .map((node) => node.id)
    .indexOf(categoryId);

  return (
    <Section as="div">
      <div className={styles.container}>
        <article className={styles.body}>{children}</article>
        <nav className={styles.nav}>
          <Type.MetaHeading as="h2">Browse topics</Type.MetaHeading>
          <CustomAccordion collapsible defaultIndex={activeNodeIndex}>
            {categoryNodes.map(({ id, name, children }) => (
              <CustomAccordionItem key={id}>
                <CustomAccordionItemHeading headingLevel="3">
                  <CustomAccordionItemButton>{name}</CustomAccordionItemButton>
                </CustomAccordionItemHeading>
                <CustomAccordionItemPanel isCompact>
                  <NavList
                    nodes={children?.map(({ id, name, uri }) => ({
                      label: name,
                      path: uri,
                      id,
                    }))}
                    isPrimary
                    showActive
                  />
                </CustomAccordionItemPanel>
              </CustomAccordionItem>
            ))}
          </CustomAccordion>
        </nav>
      </div>
    </Section>
  );
};

export default FaqLayout;
